<template>
    <div id='DotNav' class='row'>
        <div class='NavigationDots col-6' >
            <div v-for='(step, ix) in formSteps' :key='ix' class='Dot' :class="{'active': step.active }">
            </div>
        </div>
        <div class='StepNav col-6'>
            <a :class="{'hidden': activeFormIdx === 0}" class='PrevNav' @click='prevPage'>Prev</a><span>&nbsp;|&nbsp;</span>
            <a :class="{'hidden': activeFormIdx === stepsLength - 1}" class='NextNav' @click='nextPage'>Next</a>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'DotNav',
        props:['steps'],
        computed:{
            formSteps() { return Object.entries(this.$props.steps).map(step => step[1]).sort((a, b) => (a.order > b.order) ? 1 : -1) },
            activeFormIdx() { return Object.entries(this.$props.steps).map(step => step[1]).find(step => step.active).order }, 
            stepsLength(){ return Object.keys(this.$props.steps).length }
        },
        methods:{
            prevPage(){ 
                this.$emit('update-nav', {currentStepIdx: this.activeFormIdx, newStepIdx: this.activeFormIdx - 1}) 
                },
            nextPage(){
                console.log('current steps: '+ Object.entries(this.formSteps[this.activeFormIdx])); 
                this.$emit('update-nav', {currentStepIdx: this.activeFormIdx, newStepIdx: this.activeFormIdx + 1}) 
                },
        }
    }

</script>
